import React from "react";
import Modal from "../../Modal";
import { Container, Empty, IconDiv, LinkDiv, SubHeader } from "./syles";
import Resend from "../../../../assets/icons/Resend";
import Button from "../../Button";
import Link from "../../Link";

const ResendLinkModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
  onGoLogin,
  chosenEmail = "How did you manage this?",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      selector={selector}
      className={className}
      onGoLogin={onGoLogin}
    >
      <Container>
        <Empty />
        <IconDiv>
          <Resend />
        </IconDiv>
        <span>Link enviado para: {chosenEmail}</span>
        <SubHeader>
          Caso não receba o link em até 5 minutos, clique para reenviar
        </SubHeader>
        <Button
          content={"Reenviar link"}
          width={"10.8rem"}
          height={"2.815rem"}
          onClick={onConfirm}
        />
        <LinkDiv>
          <Link theme content="Voltar a tela de login" onClick={onGoLogin} />
        </LinkDiv>
      </Container>
    </Modal>
  );
};

export default ResendLinkModal;
